// extracted by mini-css-extract-plugin
export default {"container":"basic_container__Ed-km"};